var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-comment-container"},[_c('MessageArea',{attrs:{"title":"评论列表","subTitle":`(${_vm.data.total})`,"list":_vm.data.rows,"isListLoading":_vm.isLoading},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }